import { render, staticRenderFns } from "./MobileGroupHeader.vue?vue&type=template&id=1ca5c6d1&scoped=true"
import script from "./MobileGroupHeader.vue?vue&type=script&lang=js"
export * from "./MobileGroupHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileGroupHeader.vue?vue&type=style&index=0&id=1ca5c6d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5c6d1",
  null
  
)

export default component.exports